import type { LearningArticleDefinition } from "@/types/learning";

export const JOURNAL_REWRITE_ARTICLES: LearningArticleDefinition[] = [
  // 初級 (beginner)
  {
    id: "beginner-1",
    stageId: "beginner",
    title: "なぜ不動産投資？ 投資家が知るべき「3つのメリット」",
    url: "https://propally.co.jp/journal/lp/beginner-1/",
  },
  {
    id: "beginner-2",
    stageId: "beginner",
    title: "始める前に知るべき 不動産投資「5つの主要リスク」",
    url: "https://propally.co.jp/journal/lp/beginner-2/",
  },
  {
    id: "beginner-3",
    stageId: "beginner",
    title: "投資の全ステップ解説（検討～売却）",
    url: "https://propally.co.jp/journal/lp/beginner-3/",
  },
  {
    id: "beginner-4",
    stageId: "beginner",
    title: "【最重要】\"利回り\"の罠：実質利回りを見抜く",
    url: "https://propally.co.jp/journal/lp/beginner-4/",
  },
  {
    id: "beginner-5",
    stageId: "beginner",
    title: "物件種別（区分・一棟・戸建て）徹底比較",
    url: "https://propally.co.jp/journal/lp/beginner-5/",
  },
  {
    id: "beginner-6",
    stageId: "beginner",
    title: "構造（木造/RC/SRC）と「法定耐用年数」の違い",
    url: "https://propally.co.jp/journal/lp/beginner-6/",
  },
  {
    id: "beginner-7",
    stageId: "beginner",
    title: "融資（ローン）の基本：「レバレッジ」とは何か？",
    url: "https://propally.co.jp/journal/lp/beginner-7/",
  },
  {
    id: "beginner-8",
    stageId: "beginner",
    title: "初級編 用語集：押さえておきたい頻出単語",
    url: "https://propally.co.jp/journal/lp/beginner-8/",
  },
  // 中級 (intermediate)
  {
    id: "intermediate-1",
    stageId: "intermediate",
    title: "「買うべきエリア」の選定方法：データ分析の基礎",
    url: "https://propally.co.jp/journal/lp/intermediate-1/",
  },
  {
    id: "intermediate-2",
    stageId: "intermediate",
    title: "「買ってはいけない物件」の見抜き方：現地調査（内見）の全チェックリスト",
    url: "https://propally.co.jp/journal/lp/intermediate-2/",
  },
  {
    id: "intermediate-3",
    stageId: "intermediate",
    title: "物件価格の妥当性を知る（成約事例検索 活用術）",
    url: "https://propally.co.jp/journal/lp/intermediate-3/",
  },
  {
    id: "intermediate-4",
    stageId: "intermediate",
    title: "融資戦略（中級）：銀行は個人の「属性」をどう評価するか？",
    url: "https://propally.co.jp/journal/lp/intermediate-4/",
  },
  {
    id: "intermediate-5",
    stageId: "intermediate",
    title: "キャッシュフローを最大化する「税務」の知識",
    url: "https://propally.co.jp/journal/lp/intermediate-5/",
  },
  {
    id: "intermediate-6",
    stageId: "intermediate",
    title: "成功を左右する「賃貸管理会社」の選び方",
    url: "https://propally.co.jp/journal/lp/intermediate-6/",
  },
  {
    id: "intermediate-7",
    stageId: "intermediate",
    title: "「良い不動産営業マン」の見極め方と付き合い方",
    url: "https://propally.co.jp/journal/lp/intermediate-7/",
  },
  {
    id: "intermediate-8",
    stageId: "intermediate",
    title: "番外編：プロパリー　シミュレーション徹底活用術（購入編）",
    url: "https://propally.co.jp/journal/lp/intermediate-8/",
  },
  // 上級 (advanced)
  {
    id: "advanced-1",
    stageId: "advanced",
    title: "保有物件の「空室対策」実践テクニック5選",
    url: "https://propally.co.jp/journal/lp/advanced-1/",
  },
  {
    id: "advanced-2",
    stageId: "advanced",
    title: "「リノベーション」の投資対効果（ROI）算出方法",
    url: "https://propally.co.jp/journal/lp/advanced-2/",
  },
  {
    id: "advanced-3",
    stageId: "advanced",
    title: "出口戦略（売却）の最適タイミングの見極め方",
    url: "https://propally.co.jp/journal/lp/advanced-3/",
  },
  {
    id: "advanced-5",
    stageId: "advanced",
    title: "「2棟目、3棟目」を買うための融資拡大戦略",
    url: "https://propally.co.jp/journal/lp/advanced-5/",
  },
  {
    id: "advanced-6",
    stageId: "advanced",
    title: "「資産管理法人」設立のメリット・デメリットと最適タイミング",
    url: "https://propally.co.jp/journal/lp/advanced-6/",
  },
  {
    id: "advanced-7",
    stageId: "advanced",
    title: "収支の一元管理と「確定申告」の効率化",
    url: "https://propally.co.jp/journal/lp/advanced-7/",
  },
  {
    id: "advanced-8",
    stageId: "advanced",
    title: "番外編：プロパリー　シミュレーション徹底活用術（売却編）",
    url: "https://propally.co.jp/journal/lp/advanced-8/",
  },
];
